import { render, staticRenderFns } from "./RegistrationRequestDetails.vue?vue&type=template&id=bd93b49c&scoped=true"
import script from "./RegistrationRequestDetails.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestDetails.vue?vue&type=script&lang=js"
import style0 from "./RegistrationRequestDetails.vue?vue&type=style&index=0&id=bd93b49c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd93b49c",
  null
  
)

export default component.exports